import React from 'react';
import clsx from 'clsx';
import { Image } from 'semantic-ui-react';
import imagePlaceholder from '@/assets/images/role-action-placeholder.svg';

const setDefaultImage = ({ currentTarget }) => {
  const ct = currentTarget;
  ct.onerror = null;
  ct.src = imagePlaceholder;
};

const RoleActionImage = ({ src, compact, name }) => (
  <Image
    src={src}
    className={clsx(
      'aridhia-home-panel-action-image',
      compact && 'aridhia-home-panel-action-image--compact',
    )}
    alt={`${name} icon`}
    onError={(e) => setDefaultImage(e)}
  />
);

export default RoleActionImage;
